<div class="app-container">
    <app-navbar class="app-toolbar"></app-navbar>
    <div class="mainContainer">
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="ball-spin" [fullScreen]="true">
            <p style="color: white"> Loading... </p>
        </ngx-spinner>
        <router-outlet></router-outlet>
    </div>
</div>